// Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import * as PropTypes from "prop-types";
import { Module } from "../module";
import { Input, InputGroup } from "../../components/input";
import { withStore } from "../../store/withstore";
import { TranslationContext } from "../../translation";

const ResidualValue = (props) => {
	const { store: { a, b }, storeAction } = props;
	const [valueA, setValueA] = useState(a.residualValue || "");
	const [valueB, setValueB] = useState(b.residualValue || "");
	const { translate, format } = useContext(TranslationContext);

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.residualvalue.title"
			title="module.residualvalue.query"
			valueA={format(valueA, true)}
			valueB={format(valueB, true)}
			continueEnabled={Boolean(valueA && valueB)}
			onContinue={() => storeAction.setResidualValue(valueA, valueB)}
			queryA={(
				<React.Fragment>
					<InputGroup prepend="EUR" style={{ maxWidth: "265px" }}>
						<Input
							type="number"
							placeholder={translate("module.residualvalue.title")}
							value={valueA}
							onChange={(event) => setValueA(event.target.value)}
							tabIndex={(props.id === props.activeModule) ? 1 : -1}
						/>
					</InputGroup>
				</React.Fragment>
			)}
			queryB={(
				<React.Fragment>
					<InputGroup prepend="EUR" style={{ maxWidth: "265px" }}>
						<Input
							type="number"
							placeholder={translate("module.residualvalue.title")}
							value={valueB}
							onChange={(event) => setValueB(event.target.value)}
							tabIndex={(props.id === props.activeModule) ? 2 : -1}
						/>
					</InputGroup>
				</React.Fragment>
			)}
		/>
	);
};

ResidualValue.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string.isRequired,
	activeModule: PropTypes.string,
	setActiveModule: PropTypes.func
};

export default withStore(ResidualValue);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/residualvalue.js